import {isNil} from '../../helpers'
import ColorFilter from "./Filter/ColorFilter";
import Overlay from "../overlay/Overlay";

const initializeProductFilter = () => {
    const productFilters = document.querySelector('.product__filter_box__body');
    const productFilterElements = Array.from(document.querySelectorAll('.product__filter'))
    if (!isNil(productFilterElements)) {
        productFilterElements.forEach((productFilter) => {
            const colorFilter = productFilter.querySelector('.filter__color-scale');
            if (!isNil(colorFilter)) {
                new ColorFilter(colorFilter);
            }
        })
    }

    // overlay for responsive mobile view
    new Overlay(productFilters, '[data-adjust-product-filter]', 'product-filter')
}

export default initializeProductFilter;




// WEBPACK FOOTER //
// ./Private/Scripts/components/product/ProductFilter.js